(ns ycweb.weber.elements
  (:require
    [rum.core :as rum]
    [ycweb.weber.form :as f]
    [ycweb.weber.graph :as g]
    [ycweb.weber.layout :as l]
    [ycweb.util.date :as ud]
    [ycweb.util.core :as u]
    [util.string :as str]))

;(ns-unalias 'ycweb.weber.elements 'ud)

(rum/defc datepicker [name id & [value]]
  [:input.width100.dtpicker
   {:type "text"
    :name name
    :id id
    :value (if value (ud/date-format value "YYYY-MM-dd"))}])

(rum/defc slider [name id & [values & [{:keys [min max step range slider-text]}]]]
  (into
    [:div.slider-container
     (when slider-text
       [:span
        [:span.slider-text slider-text]
        [:strong
         (when values
           [:span.slider-value.color333 (str values)])]])
     [:div.slidey
      (u/maybe
        assoc {}
        :data-min min
        :data-max max
        :data-step step
        :data-range range)]]
    (if (coll? values)
      (map #(f/hidden (str name "[]") (str id "[]") (str %1)) values)
      [[:input.slider-input
        {:type "hidden" :value values :name name :id id}]])))

(rum/defc progress-bar [title percent color & {:keys [inline-text?]}]
  [:div.progress.selprogress
   [:span (when (not inline-text?) title)]
   [:div.bar
    (when inline-text? {:class "bar2"})
    [:div.value.bluebar
     {:style {"width" (str percent "%")}
      :class (str "value " color "bar")}
     (when inline-text? title)]]])

(defn progress-value [title percent color]
  {:title title :percent percent :color color})

(rum/defc progress-val [{:keys [percent color]}]
  [:div.value.redbar
   {:style {"float" "left" "width" (str percent "%")}
    :class (str "value " color "bar")}])

(rum/defc progress-legend [{:keys [title color]}]
  [:div
   [:div.bar.legendbar
    [:div.value.redbar
     {:style {"float" "left" "width" "20px" "height" "20px"}
      :class (str "value " color "bar")}]]
   [:span
    {:class "legendspan"}
    title]])

(rum/defc progress-multi [values & [legend?]]
  [:div.progress.multi
   [:div.bar.sel
    {:style {"height" "5px"}}
    (map progress-val values)]
   [:div
    (if legend?
      [:div.legend
       (map progress-legend values)])]])

(rum/defc tabs [& tabs]
  (let [tabs (remove nil? tabs)]
    [:div.tabs
     (into [:ul]
       (mapcat
         (fn [{name :name url :url fortab :id :as tab}]
           [(l/tablink name (or url (str "#" fortab)) fortab (= tab (first tabs)))])
         tabs))

     (into
       [:div]
       (map
         (fn [t]
           [:div {:id (:id t)}
            (:content t)])
         (remove :url tabs)))]))

(defn crumb [name & [url]]
  {:name name :url url})

(rum/defc breadcrumbs [crumbs & [white?]]
  (into
    [:ul.breadcrumbs.sel
     (when white? {:class "breadcrumbs2"})]
    (map
      (fn [c]
        [:li
         (if (:url c)
           [:a {:href (:url c)} (:name c)]
           (:name c))])
      crumbs)))

(rum/defc barcode-text [code text]
  [:span.barcode-span
   [:img.barcode
    (if-not (str/blank? code)
      {:data-barcode code
       :data-format "CODE128B"})]
   [:br]
   [:span.barcode-name
    {:style {:margin-left "10px"}}
    text]])

(defn barcode [code]
  (barcode-text code code))

(defn level-class [c]
  (case (int c)
    -1 "conductorcard-good"
    0 "conductorcard-normal"
    1 "conductorcard-warning"
    2 "conductorcard-error"
    "conductorcard-normal"))

(def small-graph-options
  {:height          30 :width 120
   :backgroundColor "#F2F2F2"
   :legend          {:position "none"}
   :curveType       "function"

   :hAxis           {:gridlines {:count 0 :color "#F2F2F2"} :baselineColor "#F2F2F2"}
   :vAxis           {:gridlines {:count 0 :color "#F2F2F2"} :baselineColor "#F2F2F2"}

   :series          {0 {:color "red" :visibleInLegend 0}
                     1 {:color "red" :visibleInLegend 0}}

   :trendlines      {0
                     {:type            "linear"
                      :color           "green"
                      :lineWidth       2
                      :opacity         0.3
                      :showR2          1
                      :visibleInLegend 0}}})

(defn conductor-graph [graph-data & [graph-options]]
  (g/graph
    graph-data
    [(g/h "base" :base :type :number)
     (g/h "val" :val :type :number)]
    (merge small-graph-options (or graph-options {}))
    :graphtype :line))

(rum/defc conductor-card-view [title primary & [primary-unit secondary level url content]]
  [:div.conductorcard-generic.js-generic-card
   [:a.conductorcard-url
    {:href (if url url "")}
    [:span.conductorcard-title
     {:class (str (level-class level) "-back")}
     title]]
   [:span.conductorcard-primary
    (into
      [:span {:class (level-class level)}]
      primary)
    [:sup.conductorcard-primary-unit
     {:class (level-class level)}
     primary-unit]]
   (into
     [:span.conductorcard-secondary]
     (or secondary ["&nbsp;"]))
   (when content
     (into [:span.conductorcard-graph] content))])